var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TasksCloseButton",on:{"click":_vm.closeModal}},[_c('button',[_c('IconClose')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }